import { api } from "./api";

export const createChecklist = async (body) => {
    return api.post("/check/register", body)
}

export const getChecklists = async (currentPage) => {
    return api.get(`/check?pageNumber=${currentPage}`);
}

export const downloadChecklist = async (idChecklist) => {
    return api.get(`/check/download/${idChecklist}`, {
        responseType: "blob"
    });
}